import React, { Component } from 'react'
import video from '../assets/VID-20200222-WA0009.mp4';
class PlayVideo extends Component {
    constructor(props) {
        super(props)    
        this.videoRef=React.createRef();
    }
    
    playVideo=()=>{
        console.log('Works')
        this.videoRef.current.play();    
      }   
    pauseVideo=()=>{    
        this.videoRef.current.pause();
          }
    render() {        
            return(
                <div>          
                  <video ref={this.videoRef} width="300" height="200" controls>          
                    <source src={video} type="video/mp4"></source>          
                  </video>                                            
                     <button onClick={this.playVideo}>Play</button>            
                     <button onClick={this.pauseVideo}>Pause</button>                     
                  </div>
          
              );
          
            }
        
    }


export default PlayVideo
